export type Mutation = 'updateQuotes';

export class Mutations {
    public static readonly SetAllQuotes: string = 'setAllQuotes';
    public static readonly SetAllQuotesPage: string = 'setAllQuotesPage';
    public static readonly SetAllQuotesPageSize: string = 'setAllQuotesPageSize';
    public static readonly SetAllQuotesTotalPages: string = 'setAllQuotesTotalPages';
    public static readonly SetAllQuotesTotalQuotes: string = 'setAllQuotesTotal';
    public static readonly SetAllQuotesFilterStatus: string = 'setAllQuotesFilterStatus';
    public static readonly SetAllQuotesFrom: string = 'setAllQuotesFrom';
    public static readonly SetAllQuotesTo: string = 'setAllQuotesTo';
}
